import {
  fetchEmployeeOrgchart,
  fetchAreasOrgchart,
} from "src/Pages/Company/OrganizationStructure/api";
import { useQuery } from "@tanstack/react-query";
import { OrgchartType } from "./FilterBar.models";

const useInitialOrgchartData = ({
  companyId,
  structureId,
  orgchartType,
}: {
  companyId: string;
  structureId: string;
  orgchartType: OrgchartType;
}) =>
  useQuery({
    queryKey: ["employeeOrgchart", orgchartType],
    queryFn: () =>
      orgchartType === OrgchartType.Employees
        ? fetchEmployeeOrgchart(companyId, structureId)
        : fetchAreasOrgchart(companyId, structureId),
  });

export default useInitialOrgchartData;
